/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type InvoiceList_brand$ref = any;
type InvoiceList_invoiceSettings$ref = any;
type InvoiceList_storeLists$ref = any;
export type InvoiceListQueryVariables = {|
  storeId: string
|};
export type InvoiceListQueryResponse = {|
  +storeLists: ?{|
    +$fragmentRefs: InvoiceList_storeLists$ref
  |},
  +brand: ?{|
    +$fragmentRefs: InvoiceList_brand$ref
  |},
  +invoiceSettings: {|
    +$fragmentRefs: InvoiceList_invoiceSettings$ref
  |},
|};
export type InvoiceListQuery = {|
  variables: InvoiceListQueryVariables,
  response: InvoiceListQueryResponse,
|};
*/


/*
query InvoiceListQuery(
  $storeId: ID!
) {
  storeLists {
    ...InvoiceList_storeLists_1dSt7N
    id
  }
  brand: store(id: $storeId) {
    ...InvoiceList_brand
    id
  }
  invoiceSettings {
    ...InvoiceList_invoiceSettings
    id
  }
}

fragment InvoiceList_brand on Store {
  id
  name
}

fragment InvoiceList_invoiceSettings on InvoiceSettings {
  wiringInstructions
  contactPerson
  contactPhoneNumber
  contactEmail
}

fragment InvoiceList_storeLists_1dSt7N on StoreLists {
  id
  invoices(storeId: $storeId) {
    id
    startDate
    endDate
    amountDue
    state
    invoiceNumber
    invoicePdfUrl
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId",
    "type": "ID!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "storeId",
    "variableName": "storeId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storeId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InvoiceListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreLists",
        "kind": "LinkedField",
        "name": "storeLists",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "FragmentSpread",
            "name": "InvoiceList_storeLists"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "brand",
        "args": (v2/*: any*/),
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InvoiceList_brand"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "InvoiceSettings",
        "kind": "LinkedField",
        "name": "invoiceSettings",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InvoiceList_invoiceSettings"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InvoiceListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreLists",
        "kind": "LinkedField",
        "name": "storeLists",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Invoice",
            "kind": "LinkedField",
            "name": "invoices",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "amountDue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoicePdfUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "brand",
        "args": (v2/*: any*/),
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "InvoiceSettings",
        "kind": "LinkedField",
        "name": "invoiceSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wiringInstructions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactPerson",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactPhoneNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactEmail",
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "InvoiceListQuery",
    "operationKind": "query",
    "text": "query InvoiceListQuery(\n  $storeId: ID!\n) {\n  storeLists {\n    ...InvoiceList_storeLists_1dSt7N\n    id\n  }\n  brand: store(id: $storeId) {\n    ...InvoiceList_brand\n    id\n  }\n  invoiceSettings {\n    ...InvoiceList_invoiceSettings\n    id\n  }\n}\n\nfragment InvoiceList_brand on Store {\n  id\n  name\n}\n\nfragment InvoiceList_invoiceSettings on InvoiceSettings {\n  wiringInstructions\n  contactPerson\n  contactPhoneNumber\n  contactEmail\n}\n\nfragment InvoiceList_storeLists_1dSt7N on StoreLists {\n  id\n  invoices(storeId: $storeId) {\n    id\n    startDate\n    endDate\n    amountDue\n    state\n    invoiceNumber\n    invoicePdfUrl\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b5f8f8c12fa3e2b13bb5e65d1b0afe5f';

module.exports = node;
